import BasePageLayout from '../../components/layouts/base-page-layout/base-page-layout';
import plansCombinedStore from "./stores/plans-combined-store";
import PlansCard from './components/plans-card/plans-card';
import ListLayout from '../../components/layouts/list-layout/list-layout';
import { PLAN_TYPES } from '../../models/Plan';
import { useEffect } from 'react';

const AdminSubscriptionPlanPagedListPage: React.FC = () => {
    useEffect(() => {
        plansCombinedStore.fetchSettings();
    }, []);

    return (
        <BasePageLayout title="Billing" subTitles={['Manage plans']}>
            <ListLayout>
                <PlansCard
                    pagedListStore={plansCombinedStore.getStore(PLAN_TYPES.REGULAR)}
                    type={PLAN_TYPES.REGULAR}
                    title="Subscription plans"
                />
                <PlansCard
                    pagedListStore={plansCombinedStore.getStore(PLAN_TYPES.CUSTOM)}
                    type={PLAN_TYPES.CUSTOM}
                    title="Custom plans"
                />
            </ListLayout>
        </BasePageLayout>
    );
};

export default AdminSubscriptionPlanPagedListPage;
